import Vue from 'vue';
import Router from 'vue-router';

import Home from './components/New-Home.vue';
import Login from './components/auth/Login.vue';
import Registration from './components/auth/Registration.vue';
import Aboutus from './pages/AboutUs.vue';
import Faq from './pages/Faq.vue';
import Howitworks from './pages/Howitworks.vue';
import PageNotFound from './components/NotFound.vue';
import ReturnPolicy from './pages/Retrun_policy.vue';
import YourOrders from './pages/My_Order.vue';
import Cookies_policy from './pages/Cookies_policy.vue';

import VueProgressBar from 'vue-progressbar';
Vue.use(VueProgressBar, {
    color: 'rgb(143, 255, 199)',
    failedColor: 'red',
    height: '3px',
});

Vue.use(Router);
let newVue = new Vue({});
const router = new Router({
    base: '/showroom/',
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Home',
            component: () =>
                import ('./components/Shop/Index.vue'),
            meta: {
                title: 'Home',
                layout:'new',
                newHeader:'yes'
            },
            children: [{
                path: '/',
                name: 'shop-category',
                component: () =>
                    import ('./components/Shop/Categories.vue'),
                props: true,
                meta: {
                    title: 'Shop-Category',
                },
            },
           
        {
            path: '/category/:category',
            name: 'vsdshop-category',
            component: () =>
            import ('./components/Shop/Categories.vue'),
            props: true,
            meta: {
                title: 'Shop-Category',
                layout:'new'
            },
        },
        {
            path: '/category/:category/product',
            name: 'shop-products',
            component: () =>
                import ('./components/Shop/NewProductList.vue'),
            props: true,
            meta: {
                // requiresAuth: true,
                 title: 'Product List',
                 chat: false,
                 layout:'new'
             },
        }, 
        {
            path: '/design-ai',
            name: 'design-ai',
            component: () =>
            import ('./components/MagicAi/Index.vue'),
            props: true,
            meta: { 
                layout:'new'
            },
            children: [
                {
                path: '/design-ai',
                name: 'ReadytoCreate',
                component: () =>
                    import ('./components/MagicAi/ReadytoCreate.vue'),
                props: true,
                meta: {
                    title: 'ReadytoCreate',
                },
            },                
            {
                path: '/design-ai/login',
                name: 'Account',
                component: () =>
                    import ('./components/MagicAi/login.vue'),
                props: true,
                meta: {
                    title: 'Account',
                },
            },
            {
                path: '/design-ai/singup',
                name: 'Account',
                component: () =>
                    import ('./components/MagicAi/sign-up.vue'),
                props: true,
                meta: {
                    title: 'Account',
                },
            },
            {
                path: '/design-ai/welcome',
                name: 'Account',
                component: () =>
                    import ('./components/MagicAi/welcome.vue'),
                props: true,
                meta: {
                    title: 'Account',
                },
            },
        ]
        },
        {
            path: '/login',
            name: 'Login',
            component: Login,
            meta: {
                title: 'Login',
            },
        },         
        {
            path: '/register',
            name: 'Register',
            component: Registration,
            meta: {
                title: 'Register',
            },
        },
        {
            path: '/reset_password',
            name: 'Reset_password',
            component: () =>
                import ('./components/Reset_password.vue'),
            props: true,
            meta: {
                title: 'Reset Password',
            },
        },
        {
            path: '/about_us',
            name: 'Aboutus',
            component: Aboutus,
            meta: {
                title: 'About us',
            },
        },
        {
            path: '/contact',
            name: 'Contact',
            component: () =>
                import ('./pages/Contactus.vue'),
            meta: {
                title: 'Contact us',
            },
        },
        {
            path: '/faq',
            name: 'Faq',
            component: Faq,
            meta: {
                title: 'Faq',
            },
        },
        {
            path: '/return_policy',
            name: 'ReturnPolicy',
            component: ReturnPolicy,
            meta: {
                title: 'Return Policy',
            },
        },
        {
            path: '/your_orders',
            name: 'YourOrders',
            component: YourOrders,
            meta: {
                title: 'Your Orders',
            },
        },
        {
            path: '/cookies_policy',
            name: 'Cookies_policy',
            component: Cookies_policy,
            meta: {
                title: 'Cookies Policy',
                layout:'new'
            },
        },
 
        
        {
            path: '/change_password',
            name: 'Change_password',
            component: () =>
                import ('./components/Change_password.vue'),
            meta: {
                requiresAuth: true,
                title: 'Change Password',
            },
        },
       
        {
            path: '/product/:hash/:vsd_id?',
            name: 'product_details',
            props: true,
            component: () =>
                import ('./pages/Product_Details_New.vue'),
            meta: {
                title: 'Product',
                layout:'new'
            },
        },
        {
            path: '/cart',
            name: 'Cart',
            component: () =>
                import ('./components/NewCart.vue'),
            props: true,
            meta: {
                title: 'Cart',
                requiresAuth: false,//true,
                layout:'new'
            },
        },
        {
            path: '/checkout',
            name: 'Checkout',
            component: () =>
                import ('./components/NewCheckout.vue'),
            props: true,
            meta: {
                requiresAuth: true,
                title: 'Checkout',
                layout:'new'

            },

        },
        {
            path: '/thankyou',
            name: 'Thankyou',
            component: () =>
                import ('./pages/Thankyou.vue'),
            props: true,
            meta: {
                requiresAuth: true,
            },
            meta: {
                title: 'Thankyou',
            },
        },
        {
            path: '/payout_setup',
            name: 'payout_setup',
            component: () =>
                import ('./components/Account/common/PayoutSettings.vue'),
            meta: {
                requiresAuth: true,
                title: 'Payout Settings',
            },
        },
        {
            path: '/account_verify',
            name: 'Account_verify',
            component: () =>
                import ('./components/Account_verify.vue'),
            props: true,
            meta: {
                title: 'Account verify',
            },
        },
        {
            path: '/checkout-payment',
            name: 'Checkout-payment',
            component: () =>
                import ('./components/Checkout_payment.vue'),
            props: true,
            meta: {
                requiresAuth: true,
                title: 'Checkout-payment',
            },
        },
        {
            path: '/account',
            name: '/Account',
            component: () =>
                import ('./components/Account/Index.vue'),
            meta: {
                requiresAuth: true,
                title: 'Account',
            },
            props: true,
        },
        
        {
            path: '/terms_of_service',
            name: 'terms_of_service',
            component: () =>
                import ('./pages/Terms_conditions.vue'),
            props: true,
            meta: {
                title: 'Terms & conditions',
                layout:'new'
            },
        },
        {
            path: '/privacy_policy',
            name: 'privacy_policy',
            component: () =>
                import ('./pages/Privacy_policy.vue'),
            meta: {
                title: 'Privacy Policy',
                layout:'new'
            },
        },
        {
            path: '/password_reset',
            name: 'Password_reset',
            component: () =>
                import ('./components/Forgot_password.vue'),
            props: true,
            meta: {
                title: 'Password Reset',
            },
        },
        {
            path: '/verifiction',
            name: 'Verifiction',
            component: () =>
                import ('./components/auth/Verifiction.vue'),
            meta: {
                requiresAuth: true,
                title: 'Verifiction',
            },
        },
        {
            path: '/notification',
            name: 'Notification',
            component: () =>
                import ('./pages/Notifications.vue'),
            meta: {
                requiresAuth: true,
                title: 'Notifications',
            },
        },
        {
            path: '/verify/:hash',
            name: 'Verify',
            //beforeEnter: auth,
            props: true,
            component: () =>
                import ('./components/auth/Verify.vue'),
            meta: {
                title: 'Verify',
            },
        },
        {
            path: '/product-details',
            name: 'ProductView',
            component: () =>
                import ('./pages/Product_Details_New'),
            meta: {
                title: 'ProductView',
            },
        },
        {
            path: '/404',
            component: PageNotFound,
            meta: {
                title: 'Page Not Found',
            },
        },
        {
            path: '*',
            redirect: '/404',
            meta: {
                title: 'Page Not Found',
            },
        },

 


        ],
    },
    ],
});

router.beforeResolve((to, from, next) => {
    if (to.name) {
        newVue.$Progress.start();
    }
    $('body').removeClass('modal-open');
    $('.modal-backdrop').remove();
    next();
});

router.afterEach((to, from) => {
    setTimeout(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth',
        });
    }, 100);

    newVue.$Progress.finish();
});

router.beforeEach((to, from, next) => {
    

    if(to.name=='Login' && from.name=='Cart'){
        localStorage.setItem('redirect_to', '/checkout');
    }else{
        localStorage.setItem('redirect_to', from.path);
    }


    if (to.matched.some((record) => record.meta.requiresAuth)) {
        if (!checkToken()) {
            router.push({ name: 'Login', query: { redirect: to.path } });
            /* const path = from ? from.path : '/login';
                                                                                                      router.push({
                                                                                                          path
                                                                                                      }); */
        } else {
            if (to.meta.requiresAdmin) {
                if (BaseService.isUserInRole('1')) {
                    next();
                } else {
                    //go back YOU ARE NOT AUTHORIZED
                    const path = from ? from.path : '/';
                    router.push({
                        path,
                    });
                    return;
                }
            } else if (to.meta.requiresShop) {
                if (BaseService.isUserInRole('2')) {
                    next();
                } else {
                    //go back YOU ARE NOT AUTHORIZED
                    const path = from ? from.path : '/';
                    router.push({
                        path,
                    });
                    return;
                }
            } else if (to.meta.requiresCustomer) {
                if (BaseService.isUserInRole('3')) {
                    next();
                } else {
                    const path = from ? from.path : '/';
                    router.push({
                        path,
                    });
                    return;
                }
            } else {
                next();
            }
        }
    } else {
        next(); // make sure to always call next()!
    }
});

function checkToken() {
    if (typeof localStorage.getItem('authToken') == 'undefined') return false;

    //console.warn(Vue.localStorage.get('token'));
    if (
        localStorage.getItem('authToken') != null &&
        localStorage.getItem('authToken').length > 10 &&
        typeof localStorage.getItem('authToken') != 'undefined'
    ) {
        //logger(Vue.localStorage.get('token'))
        return true;
    } else {
        // logger(false);
        return false;
    }
}

function logger(message) {
  console.log(message);
}

export default router;
